import React from "react";
import "../../styles/LearningStreams.css";  

const DegreePrograms = () => {
  const programsData = [
    {
      id: 1,
      theme: "blue", // B.Com is Blue
      title: "B.Com (Bachelor of Commerce)",
      bgImg: "https://i.pinimg.com/1200x/59/1b/c5/591bc5fcf7a18e501794135b5c8e5088.jpg",
      points: [
        "Specialisations: <strong>Accounting & Finance, Corporate Secretaryship, Taxation</strong>",
        "3-year program (UGC approved)",
        "Ideal for students aiming for CA, CMA, CS, ACCA, CPA"
      ]
    },
    {
      id: 2,
      theme: "purple", // BBA is Purple
      title: "BBA (Bachelor of Business Administration)",
      bgImg: "https://i.pinimg.com/736x/74/4a/85/744a85b2b8381cb031f9c941fb8e95b9.jpg",
      points: [
        "Focus on <strong>Management, Marketing, and Entrepreneurship</strong>",
        "Practical business training with case studies",
        "Suitable for students aiming for MBA, Business Startups"
      ]
    },
    {
      id: 3,
      theme: "green", // B.Sc is Green
      title: "B.Sc (Computer Science) – Optional Tie-up",
      bgImg: "https://i.pinimg.com/736x/fd/77/62/fd776246e277925be359a055c4e5328e.jpg",
      points: [
        "Basics of programming, AI, and business analytics",
        "For students aiming for tech + business roles"
      ]
    }
  ];

  return (
    <section className="degree-section container">
      <h2 className="section-main-title">Our Degree Programs</h2>
      
      <div className="degree-grid">
        {/* Top Row: 2 Cards */}
        <div className="row g-4 justify-content-center mb-4">
          {programsData.slice(0, 2).map((program) => (
            <div key={program.id} className="col-lg-6 col-md-12">
              <div 
                className="degree-card" 
                style={{ backgroundImage: `url(${program.bgImg})` }}
              >
                {/* Dynamic Overlay Class based on theme */}
                <div className={`degree-card-overlay overlay-${program.theme}`}></div>
                
                {/* Content */}
                <div className="degree-card-content">
                  <h3 className="degree-title">
                    {/* Dynamic Highlight Class based on theme */}
                    <span className={`title-highlight highlight-${program.theme}`}>
                      {program.title}
                    </span>
                  </h3>
                  <ul className="degree-points-list">
                    {program.points.map((point, index) => (
                      <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Row: 1 Card (Centered) */}
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
             <div 
                className="degree-card" 
                style={{ backgroundImage: `url(${programsData[2].bgImg})` }}
              >
                <div className={`degree-card-overlay overlay-${programsData[2].theme}`}></div>
                
                <div className="degree-card-content text-start text-lg-center"> 
                  <h3 className="degree-title d-inline-block">
                    <span className={`title-highlight highlight-${programsData[2].theme}`}>
                      {programsData[2].title}
                    </span>
                  </h3>
                  <div className="d-flex justify-content-lg-center">
                    <ul className="degree-points-list mt-3 text-start">
                      {programsData[2].points.map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default DegreePrograms;